import { render, staticRenderFns } from "./FormInputCana.vue?vue&type=template&id=9bfaee1c&scoped=true&"
import script from "./FormInputCana.vue?vue&type=script&lang=js&"
export * from "./FormInputCana.vue?vue&type=script&lang=js&"
import style0 from "./FormInputCana.vue?vue&type=style&index=0&id=9bfaee1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfaee1c",
  null
  
)

export default component.exports